import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom'; 
import { useEffect } from 'react';
function Login() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div className="bg-gradient-custom min-vh-100">
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-5">
          LOGIN
        </h2>
        <div className="card mx-auto shadow-sm" style={{ maxWidth: '500px' }}>
          <div className="card-body p-5">
            <div className="mb-4">
              <label htmlFor="email" className="form-label font-josefin text-secondary">Email</label>
              <input type="email" id="email" className="form-control" placeholder="Enter your email" />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="form-label font-josefin text-secondary">Password</label>
              <input type="password" id="password" className="form-control" placeholder="Enter your password" />
            </div>
            <Link to="/" className="btn btn-dark w-100 text-uppercase font-josefin">Login</Link>
            <div className="mt-3 text-center">
              <p className="font-alata text-secondary mb-0">
                Don't have an account? <Link to="/register" className="text-decoration-none text-dark fw-bold">Register</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;